import { useMemo } from "react";
import classes from "./Measurement.module.css";
import { LatLng } from "leaflet";
import L from "leaflet";
import { Marker } from "react-leaflet";
import { useOptions } from "stores/optionsStore/OptionsContext";
import { formatDistance } from "utils/formatters/formatDistance";

export type SegmentData = {
  center: LatLng;
  distance: number;
  angleFromNorth: number;
};

type Props = {
  segmentData: SegmentData[];
};

export const SegmentMarkers = ({ segmentData }: Props) => {
  const {
    state: { units },
  } = useOptions();
  return useMemo(
    () => (
      <>
        {segmentData.map((segment, index) => {
          const baseTextAngle = segment.angleFromNorth - 90;
          const limitedTextAngle =
            baseTextAngle > 90 && baseTextAngle < 270
              ? baseTextAngle - 180
              : baseTextAngle;

          const icon = L.divIcon({
            html: `<div style="transform:rotate(${limitedTextAngle}deg)">${formatDistance(
              segment.distance,
              units,
              3
            )}</div>`,
            className: classes.segmentMarker,
            iconSize: [100, 20],
            iconAnchor: [50, 10],
          });
          return (
            <Marker
              interactive={false}
              key={index}
              position={segment.center}
              icon={icon}
            />
          );
        })}
      </>
    ),
    [segmentData, units]
  );
};
